module.exports = __webpack_public_path__ + "static/media/Eye_Black_off.9307f652.svg";